import React, { useState, useEffect } from "react";
import {
  Accordion,
  Col,
  Container,
  Image,
  Nav,
  Navbar,
  NavDropdown,
  Row,
  Tab,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import BrandLogo from "../../assests/images/dc-logo.webp";
import "./index.css";
import Fade from "react-reveal/Fade";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import DCLOGOBlack from "../../assests/images/DClogo-footer.webp";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import CurrencyBitcoinIcon from "@mui/icons-material/CurrencyBitcoin";
import FavoriteIcon from "@mui/icons-material/Favorite";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function SharedNavbar() {
  let location = useLocation();
  const [industriesDropdown, setIndustriesDropdown] = useState(false);
  const [mobileIndustryOpen, setMobileIndustryOpen] = useState(false);
  const industries = [
    {
      title: "iGaming",
      path: "/industries/igaming",
      icon: <SportsEsportsIcon />,
    },
    {
      title: "Metaverse",
      path: "/industries/metaverse",
      icon: <ViewInArIcon />,
    },
    {
      title: "Blockchain",
      path: "/industries/blockchain",
      icon: <AccountTreeIcon />,
    },
    {
      title: "Fintech",
      path: "/industries/fintech",
      icon: <CurrencyBitcoinIcon />,
    },
    {
      title: "Healthcare",
      path: "/industries/healthcare",
      icon: <FavoriteIcon />,
    },
    {
      title: "AI / ML",
      path: "/industries/ai-ml",
      icon: <SmartToyIcon />,
    },
    {
      title: "Digital Marketing",
      path: "/industries/marketing",
      icon: <SmartToyIcon />,
    },
  ];

  const [activeNavLink, setActiveNavLink] = useState(location.pathname);
  const [servicesDropdownVisible, setServicesDropdownVisible] = useState(false);
  const [activeSidebar, setActiveSidebar] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false); // ✅ NEW

  useEffect(() => {
    setActiveNavLink(
      location.pathname === ""
        ? "/home"
        : location.pathname.split("/").includes("industries")
          ? "/industries"
          : location.pathname.split("/").includes("services")
            ? "/services"
            : location.pathname,
    );
  }, [location.pathname]);

  // ✅ CLEAN scroll handler
  const handlePageScroll = () => {
    setIsScrolled(window.scrollY > 0);
  };

  useEffect(() => {
    window.addEventListener("scroll", handlePageScroll);
    return () => {
      window.removeEventListener("scroll", handlePageScroll);
    };
  }, []);

  if (location.pathname === "/landing-page/software-development") {
    return null;
  }

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setActiveSidebar(open);
  };

  const toggleServicesDropdown = (visible) => {
    setServicesDropdownVisible(visible);
  };

  // ✅ CONDITIONAL LOGIC (NEW)
  const isBlogPage =
    location.pathname.includes("/blog-detail") ||
    location.pathname.includes("/blog");

  const logoSrc =
    isBlogPage || isScrolled
      ? "/images/DClogo-footer.png" // 👈 use public folder
      : "/images/dc-logo.png";

  return (
    <>
      <Navbar
        expand="lg"
        className={`navbar-styles ${isBlogPage || isScrolled ? "headerFixed" : ""}`}
      >
        <Navbar.Brand href="/">
          <Image
            src={logoSrc}
            alt="brand name"
            className={"brandImage"}
            loading="lazy"
          />
        </Navbar.Brand>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto" activeKey={activeNavLink}>
            <Nav.Link href="/" eventkey="/home">
              Home
            </Nav.Link>
            {/* <Nav.Link href="/industries" eventkey='/industries'>Industries</Nav.Link> */}
            {/* INDUSTRIES DROPDOWN */}
            <div
              className="industries-dropdown-wrapper"
              onMouseEnter={() => setIndustriesDropdown(true)}
              onMouseLeave={() => setIndustriesDropdown(false)}
            >
              <Nav.Link className="industries-nav-link" eventkey="/industries">
                INDUSTRIES
                <KeyboardArrowDownIcon className="dropdown-icon" />
              </Nav.Link>

              <div
                className={`industries-dropdown-menu ${industriesDropdown ? "show-dropdown" : ""}`}
              >
                {industries.map((item, index) => (
                  <Link
                    key={index}
                    to={item.path}
                    className="industry-dropdown-item"
                  >

                    {item.title}
                  </Link>
                ))}
              </div>
            </div>
            <Nav.Link href="/blog" eventkey="/blog">
              Blogs
            </Nav.Link>
            <Nav.Link href="/about-us" eventkey="/aboutus">
              About Us
            </Nav.Link>
            <Nav.Link href="/contact-us" eventkey="/contact-us">
              Contact Us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>

        <button className="lets-talk-btn web-view">
          <a href="/contact-us">LET'S TALK</a>
        </button>

        <div className="menu-icon mobile-view" onClick={toggleDrawer(true)}>
          <input className="menu-icon__cheeckbox" type="checkbox" />
          <div>
            <span></span>
            <span className="second-bar"></span>
            <span></span>
          </div>
        </div>
      </Navbar>

      <Drawer
        anchor={"right"}
        open={activeSidebar}
        onClose={toggleDrawer(false)}
        className="sidebar-drawer"
      >
        <Box role="presentation" className="sidebar-inner">
          <div className="brand">
            <img src="/images/DClogo-footer.png" alt="logo" />
          </div>

          <div className="links">
            <Link to="/" onClick={() => setActiveSidebar(false)}>
              Home
            </Link>

            {/* MOBILE INDUSTRIES */}

            <div className="mobile-industries-wrapper">
              <div
                className="mobile-industries-heading"
                onClick={() => setMobileIndustryOpen(!mobileIndustryOpen)}
              >
                <span>Industries</span>

                <KeyboardArrowDownIcon
                  className={`mobile-dropdown-arrow ${mobileIndustryOpen ? "rotate-arrow" : ""}`}
                />
              </div>

              {mobileIndustryOpen && (
                <div className="mobile-industries-dropdown">
                  {industries.map((item, index) => (
                    <Link
                      key={index}
                      to={item.path}
                      className="mobile-industry-item"
                      onClick={() => setActiveSidebar(false)}
                    >

                      {item.title}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link to="/blog" onClick={() => setActiveSidebar(false)}>
              Blogs
            </Link>

            <Link to="/about-us" onClick={() => setActiveSidebar(false)}>
              About Us
            </Link>

            <Link to="/contact-us" onClick={() => setActiveSidebar(false)}>
              Contact Us
            </Link>
          </div>
        </Box>
      </Drawer>
    </>
  );
}

export default SharedNavbar;
